import { cn } from '@/lib/utils';
import { useBranding } from '@/lib/branding';

/** Khối thương hiệu chung (chuẩn "Quản lý thi công"): logo + tên viết tắt của doanh nghiệp (theo Cài đặt). */
export function Brand({
  size = 'md',
  logoOnly = false,
  className,
}: {
  size?: 'sm' | 'md' | 'lg' | 'xl';
  /** Chỉ hiện logo, ẩn tên viết tắt */
  logoOnly?: boolean;
  className?: string;
}) {
  const brand = useBranding();
  const mark = {
    sm: 'size-[30px]',
    md: 'size-[37px]',
    lg: 'size-12',
    // Logo đứng riêng ở thanh menu: cao 72px, logo ngang được giãn tối đa bề rộng menu
    xl: 'h-[72px] w-auto max-w-[180px]',
  }[size];
  const text = size === 'sm' ? 'text-[20px]' : size === 'md' ? 'text-[21px]' : 'text-[26px]';
  return (
    <span className={cn('flex items-center gap-[11px] text-ink', className)}>
      <img src={brand.logoUrl} alt="" className={cn('shrink-0 object-contain', mark)} />
      {!logoOnly && <span className={cn('font-extrabold leading-none tracking-[-0.8px]', text)}>{brand.title}</span>}
    </span>
  );
}
